// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#infoTable tr td:first-child {
  padding-right: 15px;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#talentsDisplay {
  width: 100%;
}

div.sideBarTestOptionsListBorder {
  border-bottom: 1px solid #bbb;
}

.topHead {
  height: 70px;
}

.topMenu, .bottomMenu {
  background-color: #EDF2F5;
  margin: 0 0 auto 102px;
  min-width: 550px;
}

.topMenu {
  padding-top: 20px;
  border-bottom: 1px solid #ddd;
  padding-left: 20px;
}

.bottomMenu {
  padding-top: 5px;
  border-top: 1px solid #ddd;
}

.fakeListTable {
  width: 100%;
}

.fakeListTable tr {
  height: 20px;
}

.fakeListTable tr td:last-child {
  width: 20px;
}

.fakeItem {
  background-color: #dddddd;
  line-height: 12px;
}

.fakeIndicator {
  color: #dddddd;
}

.iacOutlineOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.65;
}

/**
@media (max-height:  725px ) {
    #informations {
        display: none;
    }
    #informationAltTitle {
        display: block !important;
    }
}



#informationAltTitle {
    display: none;
}

*/
/** affixing **/
.top {
  background-color: #F7F5F2;
  top: 0;
}

.fluid {
  position: relative;
  top: 125px;
}

.semiFluid {
  position: relative;
  top: 125px;
}

.blockBottom {
  position: fixed;
  padding-top: 20px;
}

.bbLeft {
  left: 102px;
  padding: 35px 20px 0 20px;
}

.bbRight {
  padding-right: 40px;
}

.iacResultsBox {
  position: relative;
  background: white;
  border: 4px solid #cecece;
  padding: 20px;
  width: 100%;
}

::ng-deep .jobLoading .backdrop, ::ng-deep .jobLoading .spinner-three-bounce {
  z-index: 1999 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/jobs/components/web/jobs-sidebar/jobs-sidebar.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,6BAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,sBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,6BAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,yBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;AACJ;;AAEI;;;;;;;;;;;;;;;;CAAA;AAkBJ,eAAA;AAEA;EACI,yBAAA;EACA,MAAA;AADJ;;AAIA;EACI,kBAAA;EACA,UAAA;AADJ;;AAIA;EACI,kBAAA;EACA,UAAA;AADJ;;AAIA;EACI,eAAA;EACA,iBAAA;AADJ;;AAIA;EACI,WAAA;EACA,yBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;AADJ;;AAIA;EACI,wBAAA;AADJ","sourcesContent":["#infoTable tr td:first-child {\n    padding-right: 15px;\n}\n\n.truncate {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n#talentsDisplay {\n    width: 100%;\n}\n\ndiv.sideBarTestOptionsListBorder {\n    border-bottom: 1px solid #bbb;\n}\n\n.topHead {\n    height: 70px;\n}\n\n.topMenu, .bottomMenu {\n    background-color: #EDF2F5;\n    margin: 0 0 auto 102px;\n    min-width: 550px;\n}\n\n.topMenu {\n    padding-top: 20px;\n    border-bottom: 1px solid #ddd;\n    padding-left: 20px;\n}\n\n.bottomMenu {\n    padding-top: 5px;\n    border-top: 1px solid #ddd;\n}\n\n.fakeListTable {\n    width: 100%;\n}\n\n.fakeListTable tr {\n    height: 20px;\n}\n\n.fakeListTable tr td:last-child {\n    width: 20px;\n}\n\n.fakeItem {\n    background-color: #dddddd;\n    line-height: 12px;\n}\n\n.fakeIndicator {\n    color: #dddddd;\n}\n\n.iacOutlineOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: white;\n    opacity: 0.65;\n}\n\n    /**\n    @media (max-height:  725px ) {\n        #informations {\n            display: none;\n        }\n        #informationAltTitle {\n            display: block !important;\n        }\n    }\n\n\n\n    #informationAltTitle {\n        display: none;\n    }\n\n    */\n\n/** affixing **/\n\n.top {\n    background-color: #F7F5F2;\n    top: 0;\n}\n\n.fluid {\n    position: relative;\n    top: 125px;\n}\n\n.semiFluid {\n    position: relative;\n    top: 125px;\n}\n\n.blockBottom {\n    position: fixed;\n    padding-top: 20px;\n}\n\n.bbLeft {\n    left: 102px;\n    padding: 35px 20px 0 20px;\n}\n\n.bbRight {\n    padding-right: 40px;\n}\n\n.iacResultsBox {\n    position: relative;\n    background: white;\n    border: 4px solid #cecece;\n    padding: 20px;\n    width: 100%;\n}\n\n::ng-deep .jobLoading .backdrop, ::ng-deep .jobLoading .spinner-three-bounce {\n    z-index: 1999 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
